import { Box } from '@mui/material';
import React from 'react';
import { use100vh } from 'react-div-100vh';

import { FloatingIsland, TexturedBackground } from '@/components/common';
import { useDevice } from '@/hooks';

interface OnboardingLayoutProps {
  children: React.ReactNode;
}
export const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({
  children,
}) => {
  const { isMobile } = useDevice();
  const fullHeight = use100vh();

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', minHeight: fullHeight }}
    >
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: fullHeight,
          width: '100%',
          position: 'relative',
        }}
      >
        <TexturedBackground />
        {/* Content */}
        <Box>{children}</Box>
      </Box>

      {!isMobile && <FloatingIsland />}
    </Box>
  );
};
